import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader-content.component.html',
  styleUrl: './loader-content.component.scss'
})
export class LoaderContentComponent {
  @Input() title:string = 'Cargando'
  @Input() text:string = ''
  @Input() isLoader:boolean = false

  @Input() textColor: 'white' | 'dark' = 'dark'; // Nueva propiedad
}
